<template>
  <v-form
    class="beneficiary-form"
    ref="beneficiaryForm"
    v-model="valid"
    :lazy-validation="lazy"
  >
    <h5 class="text-h6">{{ title }}</h5>

    <v-text-field
      label="Beneficiary Name"
      :rules="emptyRules"
      v-model="beneficiary.name"
    />
    <v-select
      label="Relative type"
      v-model="beneficiary.relative_id"
      :items="baseData.relatives"
      :rules="emptyRules"
      @change="beneficiaryChangeHandler"
      item-value="code"
      item-text="name"
    />
    <v-text-field
      :rules="emptyRules"
      v-mask="'##/##/####'"
      v-model="beneficiary.dob"
      label="Beneficiary DOB"
      placeholder="mm/dd/yyyy"
      required
    />
    <v-autocomplete
      v-model="beneficiary.location"
      :items="baseData.states"
      :rules="emptyRules"
      item-text="name"
      item-value="code"
      menu-props="auto"
      persistent-hint
      label="Beneficiary Location"
    />
    <v-text-field
      v-if="children"
      label="Grand Kids"
      :rules="emptyRules"
      v-model="beneficiary.grand_kids"
    />
    <v-select
      v-else
      label="Spouse Occupation"
      v-model="beneficiary.work_status"
      :items="baseData.jobStatus"
      :rules="emptyRules"
      item-value="name"
      item-text="name"
    />
    <v-slider
      v-model="beneficiary.percent"
      :label="`${beneficiary.percent}%`"
      :disabled="!valid"
      min="1"
      max="100"
      thumb-label
    />
    <v-btn
      class="mr-3"
      outlined
      small
      :disabled="!valid"
      @click="beneficiaryHandler"
    >
      Apply
    </v-btn>
    <v-btn outlined :disabled="!valid" small @click="autoProcentHandler">
      Auto Procent
    </v-btn>
  </v-form>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "BeneficiaryForm",
  props: {
    title: String,
    baseData: Object,
    lead_id: Number,
    beneficiary: Object,
    beneficiary_number: Number,
  },
  data() {
    return {
      lazy: false,
      valid: false,
      emptyRules: [(v) => !!v || "This field is required"],
    };
  },
  methods: {
    ...mapActions({
      showHandlerSnackbar: "snackbar/showHandlerSnackbar",
    }),

    resetBeneficiary(id) {
      if (id == 1 || id == 2) {
        this.beneficiary.work_status = null;
      } else if (id == 3 || id == 4) {
        this.beneficiary.grand_kids = null;
      } else {
        this.beneficiary.grand_kids = null;
      }
    },

    beneficiaryChangeHandler() {
      this.resetBeneficiary(this.beneficiary.relative_id);
    },

    autoProcentHandler() {
      this.$axios
        .get(
          `/beneficiaries/${this.lead_id}/${this.beneficiary_number}/autoprocent`
        )
        .then((res) => {
          this.beneficiary.percent = res.data.percent;
          this.showHandlerSnackbar({
            color: res.data.status,
            text: res.data.message,
            show: true,
          });
        })
        .catch((e) => {
          this.showHandlerSnackbar({
            color: e.response.data.status,
            text: e.response.data.message,
            show: true,
          });
        });
    },

    beneficiaryHandler() {
      this.resetBeneficiary(this.beneficiary.relative_id);

      this.$axios
        .put(`/beneficiaries/${this.lead_id}/${this.beneficiary_number}`, {
          name: this.beneficiary.name,
          dob: this.beneficiary.dob,
          relative_id: this.beneficiary.relative_id,
          location: this.beneficiary.location,
          grand_kids: Number(this.beneficiary.grand_kids),
          work_status: this.beneficiary.work_status,
          percent: this.beneficiary.percent,
        })
        .then((res) => {
          this.showHandlerSnackbar({
            color: res.data.status,
            text: res.data.message,
            show: true,
          });
        })
        .catch((e) => {
          this.showHandlerSnackbar({
            color: e.response.data.status,
            text: e.response.data.message,
            show: true,
          });
        });
    },
  },
  computed: {
    children() {
      return (
        this.beneficiary.relative_id == 1 || this.beneficiary.relative_id == 2
      );
    },
  },
};
</script>

<style lang="scss">
.beneficiary-form {
  text-align: center;
}
</style>